"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "team", {
  enumerable: true,
  get: function get() {
    return _team["default"];
  }
});
var _team = _interopRequireDefault(require("./team"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }